




































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import AddressesPopup from '@/views/app/management/components/AddressesPopup.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import Address from '@/views/app/management/components/Address.vue'
import {
  EPaymentMethodType,
  EPaymentReceiptType,
  EUserPermissions,
  IPaymentTransactionEffectiveDate
} from '@zunta/configurations'
import Api from '@/api'
import { User } from '@/classes/User'
import { formatTransactionEffectiveDate, getDecNumber } from '@/utils/helpers'
import Card from '@/components/Card.vue'
import ScheduleCallModal from '@/views/app/management/collections/components/GlobalAging/ScheduleCallModal.vue'

@Component({
  name: 'OneTimeSuccess',
  components: {
    ScheduleCallModal,
    Card,
    Address,
    AddressesPopup
  }
})
export default class OneTimeSuccess extends Vue {
  mode: 'auto' = 'auto'
  EPaymentMethodType: any = EPaymentMethodType
  EPaymentReceiptType: any = EPaymentReceiptType
  isAddressesPopupVisible: boolean = false
  isRefund: boolean = false
  user: User = Api.getUser() as User
  EUserPermissions: any = EUserPermissions
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  formatTransactionEffectiveDate: any = formatTransactionEffectiveDate
  showScheduleCallModal: boolean = false

  get fromCollections () {
    return !!this.$route.query.collectionReviewLink
  }

  get residentId () {
    return this.$route.params.residentId
  }

  get paymentId () {
    return this.$route.params.paymentId
  }

  get residentPayment () {
    return this.$store.state.resident.selectedPayment
  }

  get residentPaymentTransactions () {
    return this.$store.state.resident.selectedPaymentTransactions
  }

  get paymentContact () {
    return {
      fullName: this.residentPayment.receiptName,
      fullAddress: this.residentPayment.receiptAddress
    }
  }

  get transactionsTotal () {
    if (this.residentPayment) {
      return this.residentPayment.amount
    }
    let transactions_sum = this.residentPaymentTransactions.reduce((total: number, transaction: IPaymentTransactionEffectiveDate) => (
        parseFloat(transaction.amount.toString()) + total
    ), 0)
    if (this.residentPayment && this.residentPayment.includeSurcharge) {
      transactions_sum = getDecNumber(transactions_sum * 0.0295)
    }
    return transactions_sum
  }

  async mounted () {
    this.isRefund = this.$route.name === 'refund-success'
    this.$eventBus.$emit('loading:enable', { message: 'Loading...' })
    await this.residentModuleInstance.getResidentPayment(this.paymentId)
    setTimeout(() => this.$eventBus.$emit('loading:disable'), 300)
  }

  showReceiptPopup () {
    this.isAddressesPopupVisible = true
  }

  closeReceiptPopup () {
    this.isAddressesPopupVisible = false
  }

  async goBack () {
    if (this.user.isResident()) {
      this.$router.push({
        name: `resident-general`
      })
      return
    }

    if (this.$route.query.reviewLink) {
      const parts = (this.$route.query.reviewLink as string).split('.')
      this.$router.push({
        name: 'management-payments-review',
        params: {
          section: parts[0],
          scheduleItemId: parts[1]
        }
      })
      return
    }

    if (this.$route.query.collectionReviewLink) {
      const parts = (this.$route.query.collectionReviewLink as string).split('.')
      this.$router.push({
        name: 'management-collection-resident',
        params: {
          residentId: parts[2]
        },
        query: {
          type: parts[0]
        }
      })
      return
    }

    this.$locationManager.goBack({})
  }
}

